import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { scrollToTopOf, isValid, isText, decodeTags } from '../../../../utils';


class Question extends Component { 
	constructor(props) {
    super(props);
    this.state = {
    	showAnswer: false
    }
    this.handleClick = this.handleClick.bind(this);
  }

    handleClick() {
      this.setState({ 
      	showAnswer: !this.state.showAnswer 
      });
    }

	render() {
		const { showAnswer } = this.state;
		const { question, answer } = this.props;
		const iconClass = `faq-icon icon-close-icon-NEW ${showAnswer ? 'open' : 'close'}`;

	return (
    	<div className="faq-wrapper">
    		<div className="question-wrapper" onClick={this.handleClick}>
	    		<div className="faq-icon-wrapper">
	    			<div className={iconClass}></div>
	    		</div>
	    		<h3 className="question" dangerouslySetInnerHTML={ { __html: decodeTags(question) } } />
	    	</div>
        <p className={`answer ${showAnswer ? 'show' : 'hide'}`} dangerouslySetInnerHTML={ { __html: decodeTags(answer) } } />
      </div>
	);
}

};

Question.propTypes = {
  question: PropTypes.string,
  answer: PropTypes.string,
};

export default Question;